export default "__VITE_ASSET__CNXiMFLz__"